// extracted by mini-css-extract-plugin
export var completionBody = "_jx-2";
export var completionCard = "_jx-0";
export var completionFooter = "_jx-3";
export var completionTitle = "_jx-1";